(() => {
  const injectMalaContrastFix = () => {
    if (document.getElementById('ky-cb-mala-contrast-fix')) return;
    const style = document.createElement('style');
    style.id = 'ky-cb-mala-contrast-fix';
    style.textContent = [
      '[data-cb-mala] .cb-mala__sbtn,',
      '[data-cb-mala] .cb-mala__sbtn:link,',
      '[data-cb-mala] .cb-mala__sbtn:visited,',
      '[data-cb-mala] .cb-mala__sbtn:hover,',
      '[data-cb-mala] .cb-mala__sbtn:focus-visible{color:#fff!important;text-decoration:none!important}',
      '[data-cb-mala] .cb-mala__sbtn span{color:#fff!important}',
      '[data-cb-mala] .cb-mala__pinfo .cb-mala__sp-name{color:#4e4a55!important}',
    ].join('');
    document.head.appendChild(style);
  };

  const initMegaNav = (scope = document) => {
    scope.querySelectorAll('[data-ky-mega-nav]').forEach((root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const items = [...root.querySelectorAll('[data-kn-item]')];
      const scrim = root.querySelector('.kn-scrim');
      let closeTimer;

      const closeMegas = () => {
        items.forEach((item) => {
          item.classList.remove('open');
          item.querySelector('[data-kn-mega]')?.classList.remove('show');
          item.querySelector('.kn-link')?.setAttribute('aria-expanded', 'false');
        });
        if (!root.querySelector('[data-kn-drawer]')?.classList.contains('open')) scrim?.classList.remove('show');
      };

      const openMega = (item) => {
        window.clearTimeout(closeTimer);
        closeMegas();
        item.classList.add('open');
        item.querySelector('[data-kn-mega]')?.classList.add('show');
        item.querySelector('.kn-link')?.setAttribute('aria-expanded', 'true');
        scrim?.classList.add('show');
      };

      items.forEach((item) => {
        const link = item.querySelector('.kn-link');
        const hasMegaContent = Boolean(item.querySelector('.kn-mcols a, .kn-mcols button'));
        item.addEventListener('mouseenter', () => openMega(item));
        link?.addEventListener('click', (event) => {
          if (!hasMegaContent) return;
          if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          if (item.classList.contains('open')) return;
          event.preventDefault();
          openMega(item);
        });
        item.querySelector('[data-kn-mega]')?.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
      });

      root.querySelector('.kn-nav')?.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(closeMegas, 140);
      });

      const drawer = root.querySelector('[data-kn-drawer]');
      const opener = root.querySelector('[data-kn-drawer-open]');
      const setDrawer = (open) => {
        if (!drawer) return;
        drawer.classList.toggle('open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        opener?.setAttribute('aria-expanded', String(open));
        scrim?.classList.toggle('show', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };

      const closeNavigation = () => {
        closeMegas();
        setDrawer(false);
      };

      opener?.addEventListener('click', () => setDrawer(true));
      root.querySelectorAll('[data-kn-close]').forEach((button) => {
        button.addEventListener('click', closeNavigation);
      });
      root.querySelectorAll('.kn-acc .hd').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          const accordion = button.closest('.kn-acc');
          const open = !accordion.classList.contains('on');
          accordion.classList.toggle('on', open);
          button.setAttribute('aria-expanded', String(open));
        });
      });
      root.querySelector('[data-kn-cart-open]')?.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('ky:cart:open', { bubbles: true }));
      });
      document.addEventListener('ky:nav:close', closeNavigation);
      document.addEventListener('ky:cart:open', closeNavigation);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeNavigation();
      });
    });
  };

  const initAnnouncement = (scope = document) => {
    scope.querySelectorAll('[data-ky-announcement]').forEach((root) => {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';

      const id = root.dataset.kyAnnouncement;
      const messages = [...root.querySelectorAll('[data-message]')];
      if (root.dataset.mode === 'rotating' && messages.length > 1) {
        let index = 0;
        window.setInterval(() => {
          messages[index].classList.remove('is-active');
          index = (index + 1) % messages.length;
          messages[index].classList.add('is-active');
        }, 4500);
      }

      const mini = id ? document.querySelector(`[data-ky-announcement-mini="${CSS.escape(id)}"]`) : null;
      const clocks = [...root.querySelectorAll('[data-cd]'), ...(mini ? [...mini.querySelectorAll('[data-cd]')] : [])];
      if (clocks.length) {
        const configured = root.querySelector('[data-countdown-target]')?.dataset.countdownTarget.trim();
        let target = configured ? new Date(configured).getTime() : Date.now() + 21600000;
        if (!Number.isFinite(target)) target = Date.now() + 21600000;
        const tick = () => {
          let remaining = target - Date.now();
          if (remaining <= 0 && !configured) {
            target = Date.now() + 21600000;
            remaining = 21600000;
          }
          remaining = Math.max(0, remaining);
          const hours = Math.floor(remaining / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);
          const value = [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':');
          clocks.forEach((clock) => {
            clock.textContent = value;
          });
        };
        tick();
        window.setInterval(tick, 1000);
      }

      if (mini) {
        const updateMini = () => {
          const visible = window.scrollY > root.offsetHeight + 120;
          mini.classList.toggle('is-visible', visible);
          mini.setAttribute('aria-hidden', String(!visible));
        };
        updateMini();
        window.addEventListener('scroll', updateMini, { passive: true });
      }
    });
  };

  const init = (scope = document) => {
    injectMalaContrastFix();
    initMegaNav(scope);
    initAnnouncement(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
